var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import BaseModal from "../../modal";
export var ModalContent = styled(BaseModal.Content)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 60rem;\n"], ["\n  width: 100%;\n  max-width: 60rem;\n"])));
export var ModalBody = styled(BaseModal.Body)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding-top: 0.3rem;\n  padding-bottom: 0.3rem;\n"], ["\n  padding-top: 0.3rem;\n  padding-bottom: 0.3rem;\n"])));
export var ModalFooter = styled(BaseModal.Footer)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: nowrap;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: nowrap;\n"])));
var templateObject_1, templateObject_2, templateObject_3;